/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ControlAggregator } from '../model';
// @ts-ignore
import type { ErrorResponse } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { UpdateControl } from '../model';
/**
 * ControlsApi - axios parameter creator
 */
export const ControlsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return a single control.  Args:     control (schemas.Control, optional): The control to return.         Defaults to Depends(dependencies.get_control_by_id).  Returns:     schemas.Control: The control to return.
         * @summary Get Control
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlControlsControlIdGet: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('getControlControlsControlIdGet', 'controlId', controlId)
            const localVarPath = `/controls/{control_id}`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the control with the given id.  Args:     update_control (schemas.UpdateControl): The updated control.     control (schemas.Control, optional): The control to update.     user (schemas.OrganizationUser, optional): The current user.  Returns:     schemas.Control: The updated control.
         * @summary Update Control
         * @param {string} controlId 
         * @param {UpdateControl} updateControl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateControlControlsControlIdPatch: async (controlId: string, updateControl: UpdateControl, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('updateControlControlsControlIdPatch', 'controlId', controlId)
            // verify required parameter 'updateControl' is not null or undefined
            assertParamExists('updateControlControlsControlIdPatch', 'updateControl', updateControl)
            const localVarPath = `/controls/{control_id}`
                .replace('{control_id}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateControl, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ControlsApi - functional programming interface
 */
export const ControlsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ControlsApiAxiosParamCreator(configuration)
    return {
        /**
         * Return a single control.  Args:     control (schemas.Control, optional): The control to return.         Defaults to Depends(dependencies.get_control_by_id).  Returns:     schemas.Control: The control to return.
         * @summary Get Control
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlControlsControlIdGet(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAggregator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlControlsControlIdGet(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlsApi.getControlControlsControlIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the control with the given id.  Args:     update_control (schemas.UpdateControl): The updated control.     control (schemas.Control, optional): The control to update.     user (schemas.OrganizationUser, optional): The current user.  Returns:     schemas.Control: The updated control.
         * @summary Update Control
         * @param {string} controlId 
         * @param {UpdateControl} updateControl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateControlControlsControlIdPatch(controlId: string, updateControl: UpdateControl, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAggregator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateControlControlsControlIdPatch(controlId, updateControl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ControlsApi.updateControlControlsControlIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ControlsApi - factory interface
 */
export const ControlsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ControlsApiFp(configuration)
    return {
        /**
         * Return a single control.  Args:     control (schemas.Control, optional): The control to return.         Defaults to Depends(dependencies.get_control_by_id).  Returns:     schemas.Control: The control to return.
         * @summary Get Control
         * @param {ControlsApiGetControlControlsControlIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlControlsControlIdGet(requestParameters: ControlsApiGetControlControlsControlIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ControlAggregator> {
            return localVarFp.getControlControlsControlIdGet(requestParameters.controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the control with the given id.  Args:     update_control (schemas.UpdateControl): The updated control.     control (schemas.Control, optional): The control to update.     user (schemas.OrganizationUser, optional): The current user.  Returns:     schemas.Control: The updated control.
         * @summary Update Control
         * @param {ControlsApiUpdateControlControlsControlIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateControlControlsControlIdPatch(requestParameters: ControlsApiUpdateControlControlsControlIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ControlAggregator> {
            return localVarFp.updateControlControlsControlIdPatch(requestParameters.controlId, requestParameters.updateControl, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getControlControlsControlIdGet operation in ControlsApi.
 */
export interface ControlsApiGetControlControlsControlIdGetRequest {
    readonly controlId: string
}

/**
 * Request parameters for updateControlControlsControlIdPatch operation in ControlsApi.
 */
export interface ControlsApiUpdateControlControlsControlIdPatchRequest {
    readonly controlId: string

    readonly updateControl: UpdateControl
}

/**
 * ControlsApi - object-oriented interface
 */
export class ControlsApi extends BaseAPI {
    /**
     * Return a single control.  Args:     control (schemas.Control, optional): The control to return.         Defaults to Depends(dependencies.get_control_by_id).  Returns:     schemas.Control: The control to return.
     * @summary Get Control
     * @param {ControlsApiGetControlControlsControlIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlControlsControlIdGet(requestParameters: ControlsApiGetControlControlsControlIdGetRequest, options?: RawAxiosRequestConfig) {
        return ControlsApiFp(this.configuration).getControlControlsControlIdGet(requestParameters.controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the control with the given id.  Args:     update_control (schemas.UpdateControl): The updated control.     control (schemas.Control, optional): The control to update.     user (schemas.OrganizationUser, optional): The current user.  Returns:     schemas.Control: The updated control.
     * @summary Update Control
     * @param {ControlsApiUpdateControlControlsControlIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateControlControlsControlIdPatch(requestParameters: ControlsApiUpdateControlControlsControlIdPatchRequest, options?: RawAxiosRequestConfig) {
        return ControlsApiFp(this.configuration).updateControlControlsControlIdPatch(requestParameters.controlId, requestParameters.updateControl, options).then((request) => request(this.axios, this.basePath));
    }
}

